module.exports = __webpack_public_path__ + "img/kg.a92b7300.svg";